import axios from './request'
const moduleBI = '/store/bi'
const api = {
  // 获取快递柜信息
  getCabList: params => {
    return axios({
      url: `${moduleBI}/statistic/cabinet/express/chart/cabinetList`,
      method: 'get',
      params
    })
  },
  // 运营组列表
  getCabGroupList: params => {
    return axios({
      url: `${moduleBI}/statistic/cabinet/express/chart/groupList`,
      method: 'get',
      params
    })
  },
  // 品牌出库图表
  getCKChartByCompany: params => {
    return axios({
      url: `${moduleBI}/statistic/cabinet/wechat/chart/signBrandNumChart`,
      method: 'get',
      params
    })
  },
  // 品牌入库图表
  getRKChartByCompany: params => {
    return axios({
      url: `${moduleBI}/statistic/cabinet/wechat/chart/instoreBrandNumChart`,
      method: 'get',
      params
    })
  },
  // 柜机入库图表
  getRKChartByCabinet: params => {
    return axios({
      url: `${moduleBI}/statistic/cabinet/wechat/chart/instoreNumChart`,
      method: 'get',
      params
    })
  },
  // 柜机出库图表
  getCKChartByCabinet: params => {
    return axios({
      url: `${moduleBI}/statistic/cabinet/wechat/chart/signNumChart`,
      method: 'get',
      params
    })
  },
  // 入库/签收量总计
  getExpressNumsTotal: params => {
    return axios({
      url: `${moduleBI}/statistic/cabinet/wechat/chart/overviewData`,
      method: 'get',
      params
    })
  },
  // 导出出入库明细
  getCabExpressInOut: params => {
    return axios({
      url: `${moduleBI}/statistic/cabinet/express/chart/exportCabinetDetail`,
      method: 'get',
      params
    })
  },
  // 导出品牌明细
  getCabCompanyDetail: params => {
    return axios({
      url: `${moduleBI}/statistic/cabinet/express/chart/exportCabinetDetailByBrand`,
      method: 'get',
      params
    })
  }
}

export default api
